import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { Observable } from 'rxjs';
import { Uuid } from 'shared/common/types';
import { Criteria } from 'shared/criteria/Criteria';
import { DynamicField } from 'shared/modules/dynamic-form/field-types';

export interface ExtensionOutput {
  id: Uuid;
  name: string;
}

export interface ExtensionSettingsOutput {
  extension: ExtensionOutput;
  settings: DynamicField[];
}

@Injectable()
export class ExtensionService {
  constructor(private http: HttpClient) {}

  getAllExtensions(criteria?: Criteria): Observable<ExtensionOutput[]> {
    return this.http.get<ExtensionOutput[]>(apiUrl(`/project/extensions`, criteria));
  }

  getExtensionSettings(extensionId: Uuid): Observable<ExtensionSettingsOutput> {
    return this.http.get<ExtensionSettingsOutput>(apiUrl(`/project/extension/${extensionId}`));
  }

  updateExtensionSettings(extensionId: Uuid, settings: { [prop: string]: any }): Observable<ExtensionSettingsOutput> {
    return this.http.put<ExtensionSettingsOutput>(apiUrl(`/project/extension/${extensionId}`), settings);
  }
}
